<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <h1>New Customer - Sneak Peek Complete (excl. 'Very Few Likes')</h1>
    <SubscriptionsStatistics type="sneak_peek_complete" />
  </div>
</template>

<script>
import Vue from 'vue'

import SubscriptionsStatistics from "@/components/statistics/SubscriptionsStatistics.vue"
export default {
  components: {
    SubscriptionsStatistics
  }
}
</script>
